import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { MapPin } from "lucide-react";
import { ScrollArea } from "components/ui/scroll-area";

interface CityData {
    city: string;
    country: string;
    count: number;
}

interface GeoBlockProps {
    cities: CityData[];
}

const GeoOverviewBlock: React.FC<GeoBlockProps> = ({ cities }) => {
    return (
        <Card className="col-span-1">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">Top Locations</CardTitle>
                <MapPin className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
                <ScrollArea className="h-[200px]">
                    <div className="space-y-4">
                        {cities && cities.length > 0 ? (
                            cities.map((city, i) => (
                                <div key={i} className="flex items-center">
                                    <div className="ml-4 space-y-1">
                                        <p className="text-sm font-medium leading-none">{city.city || "Unknown"}</p>
                                        <p className="text-xs text-muted-foreground">{city.country}</p>
                                    </div>
                                    <div className="ml-auto font-medium">{city.count} visits</div>
                                </div>
                            ))
                        ) : (
                            <div className="text-sm text-muted-foreground py-4">No location data yet</div>
                        )}
                    </div>
                </ScrollArea>
            </CardContent>
        </Card>
    );
};

export default GeoOverviewBlock;
